var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.categorizedCategories),function(category){return _c('ExpencesCategory',{key:category.id,class:{ angle: !category.root },attrs:{"category":category,"isSomeCategoryEditing":_vm.isSomeCategoryEditing,"rawCategorizedCategories":_vm.rawCategorizedCategories}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }